const MILLISECONDS_PER_SECOND = 1000;

export const getSecondsUntilUTCDate = (targetDate: string): number => {
  const nowMs = Date.now();
  const targetMs = Date.parse(`${targetDate}Z`);
  const diffSec = Math.floor((targetMs - nowMs) / MILLISECONDS_PER_SECOND);
  return Math.max(diffSec, 0);
};
